import moment from "moment-timezone";

const timezone = process.env.REACT_APP_TIMEZONE;

export const formatDate = (date, format) => {
  return moment(date).tz(timezone).format(format);
};
